import axios from '../axios';

export const getPortCallsReport = (filter) => {
  return axios.get('/reports/port_calls_report', { params: filter });
};

export const getTopServicesDrilldown = (params) => {
  return axios.get('/reports/top_services_drilldown', { params });
};

export const getPortCallDetails = (params) => {
  return axios.get('/reports/port_call_details', { params });
};

export const getTopVesselsByCustomerDrilldown = (params) => {
  return axios.get('/reports/top_vessels_by_customer_drilldown', { params });
};

export const getMscReports = () => {
  return axios.get('/reports/msc_reports');
};